export default "__VITE_ASSET__D4KAk0$b__"